document.addEventListener('DOMContentLoaded', () => {
  // Only on desktop-like devices (hover + fine pointer)
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  const detailsList = Array.from(
    document.querySelectorAll('.header__inline-menu header-menu details')
  );

  detailsList.forEach((details) => {
    details.addEventListener('mouseenter', () => {
      detailsList.forEach((d) => {
        if (d !== details) d.removeAttribute('open');
      });
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  });
});